import React, { createContext, useContext, useMemo, useCallback, ReactNode } from 'react';
import { TOUR_MOCK_DATA, TourDataKey } from '../components/Tour/mockData';

interface TourModeContextValue {
  isTourMode: boolean;
  getMockData: <T>(key: TourDataKey) => T | undefined;
}

const TourModeContext = createContext<TourModeContextValue>({
  isTourMode: false,
  getMockData: () => undefined,
});

interface TourModeProviderProps {
  children: ReactNode;
}

export const TourModeProvider: React.FC<TourModeProviderProps> = ({ children }) => {
  const getMockData = useCallback(<T,>(key: TourDataKey): T | undefined => {
    return TOUR_MOCK_DATA[key] as T | undefined;
  }, []);

  const value = useMemo(() => ({
    isTourMode: true,
    getMockData,
  }), [getMockData]);

  return (
    <TourModeContext.Provider value={value}>
      {children}
    </TourModeContext.Provider>
  );
};

export const useTourMode = () => useContext(TourModeContext);

export { TourModeContext };
